export const helpSetStatus = (boolean, status, type) => {
	if (boolean) {
		if (type !== 'c-part') return 'correct';
		else if (type === 'c-part') return 'accept';
	} else
		switch (status) {
			case 'no':
				if (type === 'dz') return 'chance';
				else if (type === 'control') return 'incorrect';
				else if (type === 'c-part') return 'incorrect';
				break;
			case 'chance':
				if (type === 'dz') return 'incorrect';
				break;
			default:
				return 'accept';
		}
};
export const getVideo = ({
	video_source_type,
	video_solution,
	video_solution_platform_media,
	video_solution_iframe
}) => {
	return (video_source_type == 'youtube' || !video_source_type) 
									? video_solution : (video_source_type == 'platform') 
									? video_solution_platform_media : (video_source_type == 'iframe') 
									? video_solution_iframe : ''
}